import { renderPublication } from 'component-library/templates/Publication/render-publication'
import { getVideoQueue } from 'component-library/templates/Publication/lib/get-video-queue'
import { TheWestPublication } from 'component-library/templates/Publication/TheWestPublication/TheWestPublication'
import { PublicationRouteProps } from 'component-library/templates/Publication/SharedPublication.routing'
import { createRegisterableComponentWithData } from 'common/routing/page-definition'
import { TheWestGallery } from './TheWestGallery'
import { PublicationDataDefinitionLoader } from '../PublicationLegacyDataLoader'

export const TheWestPublicationRegistration = createRegisterableComponentWithData(
    'publication',
    PublicationDataDefinitionLoader,
    (props: PublicationRouteProps, data, services) => {
        if (data.loaded) {
            const publicationData = data.result
            // We are safe to use ! here, it will not be undefined if props.dataDefinition.publication is.
            // One will always be defined
            const publication = data.dataDefinitionArgs.publication || publicationData.publication!
            if (publication.kind === 'unknown') {
                throw new Error('Unknown Publication kind')
            }
            if (publication.kind === 'redirect') {
                throw new Error("Unknown Publication kind -> 'redirect'")
            }

            return renderPublication({
                publication,
                publicationComponent: TheWestPublication,
                galleryComponent: TheWestGallery,
                meta: props.meta,
                publicUrl: services.config.publicUrl,
                adState: services.adState,
                onEvent: services.onEvent,
                log: services.log,
                location: services.location,
                getVideoQueue: () => getVideoQueue(services, publication.id),
                relatedPublications: publicationData.relatedPublications,
                userTopicPublications: publicationData.userTopicPublications,
                toggles: services.store.getState().toggles,
                isVideoStickyEnabled: props.isVideoStickyEnabled,
            })
        }
        return null
    }
)
